const pageNameKey = "gatewaysListRow";

export const gatewaysListRowEn = {
  [pageNameKey]: {
    gatewayIconAltText: "Gateway Icon",
    addMachineText: "Add Machine",
    addMachineTooltip: "Add Machine to this Gateway",
    noSoftwareVersion: "No software version",
    noVendorIDAvailable: "No vendor ID available",
  },
};

export const gatewaysListRowPtBr = {
  [pageNameKey]: {
    gatewayIconAltText: "Ícone do Gateway",
    addMachineText: "Adicionar máquina",
    addMachineTooltip: "Adicionar máquina a este gateway",
    noSoftwareVersion: "Nenhuma versão do software",
    noVendorIDAvailable: "Nenhum ID do fornecedor disponível",
  },
};

export const gatewaysListRowDe = {
  [pageNameKey]: {
    gatewayIconAltText: "Gateway Icon",
    addMachineText: "Machine hinzufügen",
    addMachineTooltip: "Machine zu diesem Gateway hinzufügen",
    noSoftwareVersion: "Keine Softwareversion",
    noVendorIDAvailable: "Kein Hersteller-ID verfügbar",
  },
};

export const gatewaysListRowZhHans = {
  [pageNameKey]: {
    gatewayIconAltText: "网关图标",
    addMachineText: "机器添加",
    addMachineTooltip: "将机器添加到此网关",
    noSoftwareVersion: "没有软件版本",
    noVendorIDAvailable: "没有制造商ID可用",
  },
};

export const gatewaysListRowIt = {
  [pageNameKey]: {
    gatewayIconAltText: "Icona gateway",
    addMachineText: "Aggiungi macchina",
    addMachineTooltip: "Aggiungi macchina a questo gateway",
    noSoftwareVersion: "Nessuna versione del software",
    noVendorIDAvailable: "Nessun ID produttore disponibile",
  },
};

export const gatewaysListRowEs = {
  [pageNameKey]: {
    gatewayIconAltText: "Icono de gateway",
    addMachineText: "Agregar máquina",
    addMachineTooltip: "Agregar máquina a esta gateway",
    noSoftwareVersion: "Sin versión de software",
    noVendorIDAvailable: "No hay ningún proveedor ID disponible",
  },
};

export const gatewaysListRowNl = {
  [pageNameKey]: {
    addMachineText: "Machine toevoegen",
    addMachineTooltip: "Machine toevoegen aan deze gateway",
    gatewayIconAltText: "Gateway-pictogram",
    noSoftwareVersion: "Geen softwareversie",
    noVendorIDAvailable: "Geen leverancier-ID beschikbaar",
  },
};

export const gatewaysListRowTr = {
  [pageNameKey]: {
    addMachineText: "Makine Ekle",
    addMachineTooltip: "Makineyi bu Ağ Geçidine Ekle",
    gatewayIconAltText: "Ağ Geçidi Simgesi",
    noSoftwareVersion: "Yazılım sürümü yok",
    noVendorIDAvailable: "Satıcı kimliği mevcut değil",
  },
};
